angular.module('cpm').constant('EVENTS', {
    RESET_COPY: 'resetCopy',
    COPY_COMPLETE: 'copyComplete',
    SHOW_NOTIFICATION: 'showNotification',
    SET_RECENT_CAMPAIGN: 'setRecentCampaign'
});
